import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let Roll20Instructions = class Roll20Instructions extends Vue {
};
Roll20Instructions = __decorate([
    Component
], Roll20Instructions);
export default Roll20Instructions;
